module.exports = __webpack_public_path__ + "static/text-5803c55783c2dd701c1664ba5290e64f.png";